export class Airport {
  code: string;
  name: string;
  city: string;
  timezoneName: string;
}
